<template>
  <div class="data-analyse">
    <div class="data-analyse-left">
      <div class="data-box">
        <div class="data-box-title">
          过去24小时开仓
        </div>
        <div class="data-box-date">
          <span>更新时间：{{ echartsData_24H[0] ? echartsData_24H[0].CreateTime : '--' }} </span>
        </div>
        <div class="data-box-symbl">
          <div class="data-box-symbl-title">
            伦敦金
          </div>
          <div class="data-box-symbl-info">
            <span class="red">多头（{{ echartsData_24H[1] ? echartsData_24H[1].SellScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_24H[1] ? echartsData_24H[1].SellScale + '%' : '0'}`"></span>
            </div>
          </div>
          <div class="data-box-symbl-info">
            <span class="green">空头（{{ echartsData_24H[1] ? echartsData_24H[1].BuyScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_24H[1] ? echartsData_24H[1].BuyScale + '%' : '0'}`"></span>
            </div>
          </div>
        </div>
        <div class="data-box-symbl">
          <div class="data-box-symbl-title">
            伦敦银
          </div>
          <div class="data-box-symbl-info">
            <span class="red">多头（{{ echartsData_24H[0] ? echartsData_24H[0].SellScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_24H[0] ? echartsData_24H[0].SellScale + '%' : '0'}`"></span>
            </div>
          </div>
          <div class="data-box-symbl-info">
            <span class="green">空头（{{ echartsData_24H[0] ? echartsData_24H[0].BuyScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_24H[0] ? echartsData_24H[0].BuyScale + '%' : '0'}`"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-title">
          全部开仓
        </div>
        <div class="data-box-date">
          <span>更新时间：{{ echartsData_total[0] ? echartsData_total[0].CreateTime : '--' }} </span>
        </div>
        <div class="data-box-symbl">
          <div class="data-box-symbl-title">
            伦敦金
          </div>
          <div class="data-box-symbl-info">
            <span class="red">多头（{{ echartsData_total[1] ? echartsData_total[1].SellScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_total[1] ? echartsData_total[1].SellScale + '%' : '0'}`"></span>
            </div>
          </div>
          <div class="data-box-symbl-info">
            <span class="green">空头（{{ echartsData_total[1] ? echartsData_total[1].BuyScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_total[1] ? echartsData_total[1].BuyScale + '%' : '0'}`"></span>
            </div>
          </div>
        </div>
        <div class="data-box-symbl">
          <div class="data-box-symbl-title">
            伦敦银
          </div>
          <div class="data-box-symbl-info">
            <span class="red">多头（{{ echartsData_total[0] ? echartsData_total[0].SellScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_total[0] ? echartsData_total[0].SellScale + '%' : '0'}`"></span>
            </div>
          </div>
          <div class="data-box-symbl-info">
            <span class="green">空头（{{ echartsData_total[0] ? echartsData_total[0].BuyScale + '%' : '--' }}）</span>
            <div class="data-box-symbl-info-speed">
              <span class="data-box-symbl-info-speed-ratio"
                :style="`width: ${echartsData_total[0] ? echartsData_total[0].BuyScale + '%' : '0'}`"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-analyse-table">
      <h1 class="data-analyse-table-title">实时交易</h1>
      <el-table :data="tableData" style="width: 100%;overflow-y: hidden;"
        :header-cell-style="{textAlign: 'center',color:'#343436',height:'60px'}" :row-style="{height:'60px'}"
        :cell-style="{ textAlign: 'center',color:'#959595'}" :max-height="600" ref="scroll_Table"
        @mouseenter.native="autoScroll(true)" @mouseleave.native="autoScroll(false)"
        :row-class-name="tableRowClassName">
        <el-table-column prop="Account" label="用户账号">
        </el-table-column>
        <el-table-column prop="Time" label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.Time ? scope.row.Time.substring(11, 20) : '' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="Price"
          label="报价">
        </el-table-column> -->
        <el-table-column prop="Price" label="成交价格">
        </el-table-column>
        <!-- <el-table-column
          prop="strOpenClose"
          label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.strOpenClose == 'open'" style="color: #11C771;">建仓</span>
            <span v-if="scope.row.strOpenClose == 'close'" style="color:  #FA2314;">平仓</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="strSymbol" label="产品">
          <template slot-scope="scope">
            <span v-if="scope.row.Symbol == 'GOLD'">伦敦金</span>
            <span v-if="scope.row.Symbol == 'SILVER'">伦敦银</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="strBuySell"
          label="买/卖">
          <template slot-scope="scope">
            <span v-if="scope.row.Command == 'OP_BUY' ">买</span>
            <span v-if="scope.row.Command == 'OP_SELL' ">卖</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="strBuySell" label="订单类型">
          <template slot-scope="scope">
            <span v-if="scope.row.Command == 'OP_BUY'" style="color: #11C771;">多单</span>
            <span v-if="scope.row.Command == 'OP_SELL'" style="color:  #FA2314;">空单</span>
          </template>
        </el-table-column>
        <el-table-column prop="Volume" label="手数">
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
import { number } from 'echarts';
import {datacenterInit,datacenterGoldSilv,DataCenter_GoldSilverPos_Total} from '../../../api/info';

import { queryGoldSilverComman, queryGetGoldSilver, GetRealTimeOrder } from '@/apis/common'
export default {
  data() {
    return {
      // 表格数据
      tableData: [],
      // echarts数据
      echartsData_24H:[],
      echartsData_total:[],
      scrolltimer: '', // 自动滚动的定时任务
    }
  },
  created(){
    // 获取表格数据
    // datacenterInit({size:14,days:14}).then(res=>{
    //   if(res.IsSuccess == true){
    //     this.tableData = res.Message;

    //     this.autoScroll()

    //   }
    // }).catch(err=>{
    //   console.log(err);
    // })
    // // 获取echarts-24H数据
    // datacenterGoldSilv().then(res=>{
    //   if(res.IsSuccess == true){
    //     this.echartsData_24H = res.Message;
    //   }
    // }).catch(err=>{
    //   console.log(err);
    // })
    // // 获取echarts-total数据
    // DataCenter_GoldSilverPos_Total().then(res=>{
    //   if(res.IsSuccess == true){
    //     this.echartsData_total = res.Message;
    //   }
    // }).catch(err=>{
    //   console.log(err);
    // })

    // 新24h开仓
    queryGoldSilverComman({ "hours": "24" }).then(res => {
 

      this.echartsData_24H = [];
      if (res.length > 0) {
        this.echartsData_24H = res;

      } else {
        this.echartsData_24H = [];

      }

    }).catch(err => {
      console.log(err);
    })
    // 全部开仓
    queryGoldSilverComman().then(res => {
  
      this.echartsData_total = res;

    }).catch(err => {
      console.log(err);
    })

    GetRealTimeOrder().then(res => {
      
      if (res) {
        res.map(item => {
          item.Account = String(item.Account).replace(String(item.Account).substring(2, String(item.Account).length - 2), '****')

        })
      }
      this.tableData = res;

      this.autoScroll()
    })

  },
  methods:{
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex%2==0 ) {
        return "warning-row";
      } else{
        return "success-row";
      }
    },
    // 设置自动滚动
    autoScroll(stop) {
      const table = this.$refs.scroll_Table
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer)
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (divData.clientHeight + divData.scrollTop+1 > divData.scrollHeight) {
        
            // 重置table距离顶部距离
            divData.scrollTop -= 60
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 150) // 滚动速度
      }
    },

  },
  destroyed(){
    this.autoScroll(true)
  }
}
</script>

<style lang="less" scoped>
  .data-analyse{

    display: flex;
    justify-content: space-between;

    .red {
      color: #FA2314;
    }
    .green {
      color: #11C771;
    }

    &-left {
      width: 428px;
      flex-shrink: 0;

      .data-box {
        background: #fff;
        padding: 30px;

        &:first-child {
          margin-bottom: 25px;
        }

        &-title {
          color: #000;
          font-size: 24px;
          font-weight: 700;

        }
        &-date {
          color: #93939F;
          font-size: 14px;
          margin: 10px 0;
        }

        &-symbl {
          line-height: 40px;

          &-title {
            color: #000;
            font-size: 18px;
            font-weight: 700;
          }

          &-info {
            display: flex;
            align-items: center;

            >span {
              width: 120px;
            }
            &-speed {
              flex: 1;
              position: relative;
              margin-left: 10px;
              height: 16px;
              background: #f5f5f5;
              border-radius: 16px;

              &-ratio {
                position: absolute;
                left: 0;
                top: 0;
                height: 16px;
                background: #FA2314;
                border-radius: 16px;
                background: linear-gradient(to right, #FA2314, #DB2C23);
              }
            }
            &:last-child {
              .data-box-symbl-info-speed-ratio {
                background: linear-gradient(to right, #11C771, #0AAF61);
              }
            }
          }
        }
      }

    }
  
    &-table {
      padding: 30px;
      width: 786px;
      flex-shrink: 0;
      background: #fff;
      box-sizing: border-box;

      &-title {
        font-size: 24px;
        color: #000;
        font-weight: 700;
        margin: 0 0 20px;
      }
      /deep/ .el-table .warning-row {

      background: rgba(255, 250, 243, 1);
      }
      
      /deep/.el-table .success-row {
        background: #fff;
      }
      /deep/ .el-table--scrollable-y .el-table__body-wrapper {
        overflow-y: hidden;
      }
      
      /deep/ .el-table__row{
        height: 76px;
        td {
          &:nth-child(1) {
            color:#000 !important;
            font-weight: 600;
           
          }
      
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .data-analyse{
      display: flex;
      align-items: center;
      flex-direction: column;
      .data-analyse-left{
        width: 100%;
        .data-box{
        .data-box-title{
          font-size: 16px;
        }
        .data-box-date{
          font-size: 12px;
        }
        &-symbl {
          &-title {
            font-size: 14px;
          }
        }

        }
      }
      .data-analyse-table{
        width: 100%;
        .data-analyse-table-title{
          font-size: 16px;
        }
      }
    }
  }
    // -------------------------小屏幕适配-------------------
  @media screen and (min-width: 1264px) and (max-width: 1724px) {
  .data-analyse {
  
      display: flex;
      justify-content: space-between;
  
      .red {
        color: #FA2314;
      }
  
      .green {
        color: #11C771;
      }
  
      &-left {
        width: 364px;
        flex-shrink: 0;
  
        .data-box {
          background: #fff;
          padding: 30px;
  
          &:first-child {
            margin-bottom: 25px;
          }
  
          &-title {
            color: #000;
            font-size: 24px;
            font-weight: 700;
  
          }
  
          &-date {
            color: #93939F;
            font-size: 14px;
            margin: 10px 0;
          }
  
          &-symbl {
            line-height: 40px;
  
            &-title {
              color: #000;
              font-size: 18px;
              font-weight: 700;
            }
  
            &-info {
              display: flex;
              align-items: center;
  
              >span {
                width: 120px;
              }
  
              &-speed {
                flex: 1;
                position: relative;
                margin-left: 10px;
                height: 16px;
                background: #f5f5f5;
                border-radius: 16px;
  
                &-ratio {
                  position: absolute;
                  left: 0;
                  top: 0;
                  height: 16px;
                  background: #FA2314;
                  border-radius: 16px;
                  background: linear-gradient(to right, #FA2314, #DB2C23);
                }
              }
  
              &:last-child {
                .data-box-symbl-info-speed-ratio {
                  background: linear-gradient(to right, #11C771, #0AAF61);
                }
              }
            }
          }
        }
  
      }
  
      &-table {
        padding: 30px;
        width: 654px;
        flex-shrink: 0;
        background: #fff;
        box-sizing: border-box;
  
        &-title {
          font-size: 24px;
          color: #000;
          font-weight: 700;
          margin: 0 0 20px;
        }
  
        /deep/ .el-table__row {
          height: 76px;
  
          td {
            &:nth-child(1) {
              color: #000 !important;
              font-weight: 600;
  
            }
  
          }
        }
      }
    }
  }
</style>